import "./dropdown.css";

import Select from "react-select";
import { customStyles } from "../Svt-Admin/ModalComponent/MultiSelectStyle";

const Dropdown = ({
    options,
    placeholder,
    onDropdownChange,
    isDisabled,
    value,
    isMultiSelect,
}) => {
    const handleSelectChange = (selectedOptions) => {
        onDropdownChange && onDropdownChange(selectedOptions);
    };
    const handleAllOptionSelect = () => {
        const allOptions = options;
        onDropdownChange && onDropdownChange(allOptions);
    };

    const customOptions = [{ value: "all", label: "All" }, ...options];

    return (
        <div className="dropdown-container">
            {isMultiSelect ? (
                <Select
                    isMulti
                    className="dropdown-select"
                    options={customOptions}
                    value={value}
                    onChange={(selectedOptions) => {
                        if (
                            selectedOptions.some(
                                (option) => option.value === "all"
                            )
                        ) {
                            handleAllOptionSelect();
                        } else {
                            handleSelectChange(selectedOptions);
                        }
                    }}
                    isDisabled={isDisabled}
                    styles={{
                        ...customStyles,
                        container: (provided) => ({
                            ...provided,
                            width: 180,
                            minWidth: 0,
                        }),
                        control: (provided) => ({
                            ...provided,
                            minWidth: 0,
                            width: 160,
                            maxHeight: 80,
                        }),
                        valueContainer: (provided) => ({
                            ...provided,
                            maxHeight: 80,
                            overflowY: "auto",
                        }),
                    }}
                    placeholder={placeholder}
                    closeMenuOnSelect={false}
                />
            ) : (
                <select
                    className="dropdown-select"
                    value={value}
                    onChange={(event) => onDropdownChange(event.target.value)}
                    disabled={isDisabled}
                >
                    <option value="" disabled>
                        {placeholder}
                    </option>
                    {options?.map((option) => (
                        <option
                            className="dropdown-option"
                            key={option.value}
                            value={option.value}
                        >
                            {option.label}
                        </option>
                    ))}
                </select>
            )}
        </div>
    );
};

export default Dropdown;
